import script from "./Footer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Footer.vue?vue&type=script&setup=true&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=1ed63317&lang=css"

const __exports__ = script;

export default __exports__